var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"terms-and-conditions-modal","scrollable":"","title":"Terms and Conditions","size":"xl","hide-footer":""}},[_c(`${_vm.capitalizeFirstLetter(_vm.locale)}TermsAndConditionsContent`,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }